var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex justify-center text-white fixed w-full p-2 bg-theme-darkest z-50 h-20"},[_c('div',[_c('router-link',{attrs:{"to":"/homepage","data-cy":"home"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/lightyear-logo.png"),"alt":"Lightyear logo"}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }